"use client";

import { Stack, Typography } from "@mui/material";
import { ChainId } from "config/wagmi";
import { BigNumberish } from "ethers";
import BridgePromLabel from "modules/bridge/assets/BridgeType.svg";
import HyperLine from "modules/bridge/assets/Hyperlane.svg";
import { Fee } from "modules/bridge/components/Fee";
import { timeByChainId } from "modules/bridge/config";
import { bsc } from "wagmi/chains";

interface Props {
  amount?: string;
  nativeToken?: string;
  fee?: BigNumberish;
  chainIdTo: ChainId;
  chainIdFrom: ChainId;
  symbol?: string;
  isHyperLine?: boolean;
  origin?: string;
  destination?: string;
  tokenIndex?: number;
  recipient?: Address;
}

export const BridgeInfo = ({
  amount = "0.00",
  fee,
  nativeToken = "",
  chainIdTo,
  chainIdFrom,
  symbol,
  isHyperLine,
  origin,
  destination,
  tokenIndex,
  recipient,
}: Props) => {
  return (
    <Stack
      spacing={3}
      width="100%"
      border="1px solid #D0D0D0"
      padding={4}
      borderRadius={2}
    >
      <Stack sx={{ flexDirection: "row", justifyContent: "space-between" }}>
        <Typography variant="body1" color="text.disabled">
          Bridge Provider
        </Typography>
        {[bsc.id].includes(chainIdFrom as 56) ||
        [bsc.id].includes(chainIdTo as 56) ||
        isHyperLine ? (
          <HyperLine />
        ) : (
          <BridgePromLabel />
        )}
      </Stack>
      <Stack sx={{ flexDirection: "row", justifyContent: "space-between" }}>
        <Typography variant="body1" color="text.disabled">
          You will receive
        </Typography>

        <Typography variant="body1" color="text.disabled">
          {amount} {symbol}
        </Typography>
      </Stack>
      {isHyperLine && origin && destination && tokenIndex && recipient ? (
        <Fee destination={destination} tokenIndex={tokenIndex} />
      ) : null}
      <Stack sx={{ flexDirection: "row", justifyContent: "space-between" }}>
        <Typography variant="body1" color="text.disabled">
          Time
        </Typography>

        <Typography variant="body1" color="text.disabled">
          {
            timeByChainId?.[chainIdFrom as keyof typeof timeByChainId]?.[
              chainIdTo as keyof typeof timeByChainId
            ]
          }
        </Typography>
      </Stack>
    </Stack>
  );
};
